<div class="sample-question-review">
  <ng-content select="[sample-result-header]"></ng-content>
  <hr/>
  <div class="question-review-viewport">
    <div class="section-question-list">
      <div *ngFor="let section of sections; let sectionIndex = index" [class.is-hidden]="hideUnscoredSections && (!section.isShuffleDisabled || section.disableScoring)">
        <div class="question-summary-section">
          <tra [slug]="sectionTitleSlug"></tra>
          {{sectionIndex + 1}}
          <tra slug="of_enum"></tra>
          {{sections.length}}
          : <tra [slug]="section.caption"></tra>
        </div>
        <div class="question-row-container">
          <div *ngFor="let questionId of section.questions; let qIndex = index;" class="question-row">
            <button class="button"
              [class.is-text]="questionId != getActiveQuestionId()"
              [class.is-info]="questionId == getActiveQuestionId()"
              (click)="selectSectionAndQuestion(sectionIndex, qIndex)"
            >
              <span class="validation-icon">
                <i *ngIf="getQuestionScore(questionId)" class="is-correct fa fa-check-circle-o" title="Correct" aria-hidden="true"></i>
                <i *ngIf="!getQuestionScore(questionId)" class="is-incorrect fa fa-times-circle-o" title="Incorrect" aria-hidden="true"></i>
              </span>
              <tra slug="title_question"></tra>
              <span style="margin-left: 0.2em;">{{qIndex + 1}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="section-question-preview" #questionReviewRunner>
      <div style="margin-bottom:0.5em;" class="question-identifier"> <strong>
        <tra [slug]="sectionTitleSlug"></tra>
        {{currentSectionIndex + 1}},
        <tra slug="title_question"></tra>
        {{currentQuestionIndex + 1}}
      </strong> </div>
      <question-runner
        [currentQuestion]="getActiveQuestionContent()"
        [currentQuestionIndex]="0"
        [totalQuestions]="4"
        [isSubmitted]="true"
        [questionState]="getActiveQuestionState()"
      ></question-runner>
    </div>
  </div>

  <hr/>
  <div *ngIf="showLeaveButton">
    <button class="button footer-btn is-large is-info" (click)="leave.emit()">
      <tra slug="btn_leave_sample_q_r"></tra>
    </button>
  </div>
  <ng-content select="[sample-result-footer]"></ng-content>
</div>
